module.exports = __webpack_public_path__ + "img/EurekampsLogo2Clean.a827dd24.png";